import React, { Component } from 'react';
export default class ValidateSlider extends Component {
    constructor(props) {
        super(props);
        this.statuses = {
            START: 0,
            MOVING: 1,
            STOP: 2,
            COMPLETE: 3
        };
        this.state = {
            sliderLeft: 0,
            text: this.props.initText || "请拖动滑块至最右侧",
            successWidth: 0,
            sliderHtml: <span>>></span>
        }
    }
    componentDidMount() {
        document.addEventListener("mousemove", this.moving.bind(this));
        document.addEventListener("mouseup", this.stop.bind(this));
        document.addEventListener("touchmove", this.moving.bind(this));
        document.addEventListener("touchend", this.stop.bind(this));
    }
    stop() {
        if (this.status === this.statuses.MOVING) {
            this.setState({
                sliderLeft: 0,
                successWidth: 0
            });
        }
        this.status = this.statuses.STOP;
    }
    start(event) {
        if (this.status === this.statuses.COMPLETE) {
            return;
        }
        this.status = this.statuses.START;
        this.startX = this.getClientX(event);
    }
    getClientX(event) {
        if (event.touches && event.touches[0]) {
            return event.touches[0].clientX;
        }
        return event.clientX;
    }
    moving(event) {
        let clientX = this.getClientX(event);
        if (this.status === this.statuses.START || this.status === this.statuses.MOVING) {
            this.status = this.statuses.MOVING;
            let x = clientX - this.startX;
            let maxDistance = this.componentWidth - this.componentHeight;
            if (x > 0) {
                this.setState({
                    sliderLeft: Math.min(x, maxDistance),
                    successWidth: Math.min(x, maxDistance)
                });
            }
            if (x >= maxDistance) {
                this.status = this.statuses.COMPLETE;
                this.props.onValidateComplete && this.props.onValidateComplete({
                    success: true
                });
                this.setState({
                    text: this.props.completeText || "验证成功",
                    sliderLeft: maxDistance,
                    sliderHtml: (<span style={{
                        background: "#7ac23c",
                        padding: "0px 4px",
                        borderRadius: "50%",
                        color: "#fff"
                    }}>√</span>)
                })
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener("mousemove", this.moving);
        document.removeEventListener("mouseup", this.stop);
        document.removeEventListener("touchmove", this.moving);
        document.removeEventListener("touchend", this.stop);
    }
    render() {
        let width = this.componentWidth = this.props.width || 280;
        let height = this.componentHeight = this.props.height || 40;
        let rootStyle = {
            position: "relative",
            width: width,
            height: height,
            background: "#ddd",
            border: "1px solid #ccc",
            borderRadius: "2px"
        };
        let textStyle = {
            lineHeight: height + "px",
            position: "absolute",
            textAlign: "center",
            height: height - 2
        };
        let sliderStyle = {
            position: "absolute",
            width: height - 2,
            height: height - 2,
            top: 0,
            left: this.state.sliderLeft,
            lineHeight: (height - 2) + "px",
            background: "#fff",
            textAlign: "center",
            cursor: "pointer",
            userSelect: "none"
        }
        return <div style={rootStyle}>
            <div style={{ ...textStyle, width: width - this.state.successWidth, right: 0 }}></div>
            <div style={{ ...textStyle, width: this.state.successWidth, left: 0, background: "#7ac23c" }}></div>
            <div style={{ ...textStyle, width: "100%" }}>{this.state.text}</div>
            <div style={sliderStyle} ref={el => this.sliderEl = el} onMouseDown={event => {
                this.start(event);
            }} onTouchStart={event => {
                this.start(event);
            }}>{this.state.sliderHtml}</div>
        </div>
    }
}